/* eslint-disable @typescript-eslint/no-explicit-any */
import { UserRoles } from '@/models/enums/auth/UserRoles'
import { apiClient } from '@/plugins/axios/api'
import type { AxiosResponse } from 'axios'

export class UserService {
  static async createUser(values: Partial<any>): Promise<AxiosResponse> {
    // we prepare the payload to match the API expectations
    const payload: any = {
      ...values,
      //logo: {}, handled while updating account
      userRequestedRoles: [UserRoles.USER],
      hasSeenUserRequestedRoles: true,
    }
    // we remove properties that should not be sent to the API
    delete payload.confirmUserLogin
    delete payload.roles
    return apiClient.post('/api/utilisateurs', JSON.stringify(payload), {
      headers: { 'Content-Type': 'application/ld+json' },
    })
  }

  static async patchUser(values: Partial<any>, userID: number): Promise<AxiosResponse> {
    return apiClient.patch(`/api/utilisateurs/${userID}`, JSON.stringify(values), {
      headers: { 'Content-Type': 'application/merge-patch+json' },
    })
  }

  static async deleteUser(user: any): Promise<AxiosResponse> {
    return apiClient.delete(`/api/utilisateurs/${user.id}`)
  }
}
